import { createReducer } from '@reduxjs/toolkit';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { benchmarkActions } from '~/behaviors/actions/benchmark.actions';
import { handleUnsafeOptionalChaining } from '~/tools/lint/handleUnsafeOptionalChaining';

const reset = () => defaultState;

const defaultState = {};

const replaceQuestions = (state, action) => {
  const questions = action?.payload?.benchmarkQuestions.entities.benchmarkQuestions;
  const surveyTypeId = action?.payload?.surveyTypeId;
  if (questions || surveyTypeId) state[surveyTypeId] = questions;

  return state;
};

const mergeMappings = (state, action) => {
  const { benchmarkQuestionId, newMappings, surveyTypeId } = handleUnsafeOptionalChaining(action?.payload);
  if (!benchmarkQuestionId || !newMappings || !surveyTypeId) return state;

  if (!state[surveyTypeId]?.[benchmarkQuestionId]?.associatedQuestions) return state;
  for (const mapping of newMappings) {
    state[surveyTypeId][benchmarkQuestionId].associatedQuestions[mapping.questionId] = mapping;
  }

  return state;
};

const removeMappings = (state, action) => {
  const { benchmarkQuestionId, surveyQuestionIds, surveyTypeId } = handleUnsafeOptionalChaining(action?.payload);
  if (!benchmarkQuestionId || !surveyQuestionIds || !surveyTypeId) return state;

  const currentMappings = state[surveyTypeId]?.[benchmarkQuestionId]?.associatedQuestions;
  if (!currentMappings) return state;
  for (const surveyQuestionId of surveyQuestionIds) {
    delete currentMappings[surveyQuestionId];
  }

  return state;
};

const updateTaggedQuestionCount = (state, action) => {
  const { surveyTypeId, benchmarkQuestionId, addedMappings, removedMappings } = handleUnsafeOptionalChaining(
    action?.payload,
  );
  if (!surveyTypeId || !benchmarkQuestionId) return state;

  const currentCount = state[surveyTypeId][benchmarkQuestionId]?.taggedQuestionCount || 0;
  const newCount = currentCount + addedMappings - removedMappings;

  state[surveyTypeId][benchmarkQuestionId].taggedQuestionCount = newCount;

  return state;
};

const benchmarkQuestions = createReducer(defaultState, (builder) => {
  builder
    .addCase(metaActions.reset, reset)
    .addCase(benchmarkActions.fetchBenchmarkQuestions.fulfilled, replaceQuestions)
    .addCase(benchmarkActions.associateQuestionsWithBenchmarkQuestion.fulfilled, mergeMappings)
    .addCase(benchmarkActions.delBenchmarkQuestionAssociations.fulfilled, removeMappings)
    .addCase(benchmarkActions.fetchTaggedSurveyQuestions.fulfilled, mergeMappings)
    .addCase(benchmarkActions.updateTaggedQuestionCount, updateTaggedQuestionCount);
});

export { benchmarkQuestions };
